export const flatfileProviderConfig = {
  exitTitle: "Info",
  exitText:
    "All your changes have been saved. You can re-open the uploader at any time to continue.",
  exitPrimaryButtonText: "Close",
  exitSecondaryButtonText: "Go back"
};
